export default "__VITE_ASSET__BkqgydRp__"